import {Component, OnInit} from '@angular/core';
import {MaintenanceService} from '../services/maintenance.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  message = 'Наразі сервіс тимчасово недоступний у зв’язку з проведенням технічних робіт.';

  constructor(private maintenanceService: MaintenanceService) {}

  ngOnInit() {
    this.maintenanceService.getStatus().subscribe(
      status => this.message = status.message || this.message,
      () => {}
    );
  }
}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/maintenance/maintenance.component.ts